import { gql } from '@apollo/client';

export const PROFILES_QUERY = gql`
query certificateProfiles {
    certificateProfiles {
      edges {
        node {
          id
          name
          description
        }
      }
    }
  }
`;